/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TSaveSurveyModel,
  ISaveSurveyRequest,
  IMappers,
  ISaveSurveyResponse,
  ISaveSurveyResponseError,
  TSaveSurveyResponse,
} from './types';

const defaultConfig: TSaveSurveyModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'commercial-analytics',
  pathApi: '/v1/save-survey/',
  hostType: 'ud-api',
} as TSaveSurveyModel;

function createSaveSurveyModel(parameters: ISaveSurveyRequest): TSaveSurveyModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISaveSurveyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ISaveSurveyRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchSaveSurvey<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ISaveSurveyOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TSaveSurveyResponse> {
  const { response, statusCode } = await httpApi.fetch(createSaveSurveyModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISaveSurveyResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ISaveSurveyResponseError);
    }
  }

  return { response, statusCode } as TSaveSurveyResponse;
}

export { defaultConfig, createSaveSurveyModel, fetchSaveSurvey };
